export default function obterIniciaisNomeUsuario(nome: string) {
  if (!nome) return '';

  const palavras = nome.trim().split(' ');
  let iniciais = palavras[0]?.[0] || '';
  if (palavras.length > 1) {
    iniciais += palavras[1]?.[0] || '';
  }
  return iniciais.toUpperCase();
}
